// Çalışan Finans Yönetimi tablosunun sütunları (eski tablonun anahtarları ve
// seçenekleri). Metinler: employeeFinance.columns.<key>; seçeneklerin
// değerleri kayıtlı değerlerdir.

export const EF_COLUMNS = {
  eName: { type: 'text', width: 170 },
  eSurname: { type: 'text', width: 170 },
  tcNumber: { type: 'text', width: 150 },
  phone: { type: 'text', width: 160 },
  departman: { type: 'text', width: 180 },
  Active: { type: 'select', width: 120 },
  eMail: { type: 'text', width: 240 },
  startDate: { type: 'date', width: 160 },
  workType: { type: 'select', width: 160 },
  address: { type: 'text', width: 240 },
  annualPermit: { type: 'text', width: 130 },
  birthday: { type: 'date', width: 150 },
  isHandicappedPerson: { type: 'select', width: 170 },
  isIntern: { type: 'select', width: 120 },
  isRetired: { type: 'select', width: 120 },
  languageInfo: { type: 'text', width: 180 },
  nationality: { type: 'text', width: 140 },
  profession: { type: 'text', width: 180 },
  educationInfo: { type: 'select', width: 240 },
};

export const COLUMN_KEYS = Object.keys(EF_COLUMNS);

// Geniş ekranda tablo boş görünmesin: eski 6 sütuna e-posta, başlangıç tarihi
// ve çalışma şekli eklendi; diğerleri sütun menüsünden açılır
const VISIBLE = ['eName', 'eSurname', 'tcNumber', 'phone', 'departman', 'Active', 'eMail', 'startDate', 'workType'];
export const DEFAULT_VISIBLE_COLUMNS = Object.fromEntries(COLUMN_KEYS.map((key) => [key, VISIBLE.includes(key)]));
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['eName', 'eSurname'];

export const YES_NO_KEYS = ['isHandicappedPerson', 'isIntern', 'isRetired'];

export const EDUCATION_OPTIONS = [
  'Ortaokul / Ortaöğretim',
  'Lise',
  'Ön Lisans (2 Yıllık Üniversite)',
  'Lisans (4 Yıllık Üniversite)',
  'Yüksek Lisans (Master)',
  'Doktora (PhD)',
];

export const WORK_TYPES = ['Full Time', 'Part Time'];

// Durum anahtarı: '1' aktif, '0' inaktif, '' hepsi (eski filtre: Active = '1' ile açılır)
export const STATUS_VALUES = ['1', '0', ''];
export const DEFAULT_FILTERS = { Active: '1' };

/** 'Yes' / true → yes; 'No' / false / empty → no. */
export const isYes = (value) => value === true || String(value).toLowerCase() === 'yes' || String(value).toLowerCase() === 'true' || value === 1;

export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
